import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    agreement: {
      description: {
        review: 'Terms and Conditions signed',
      },
      label: {
        add: 'Terms and Conditions',
        review: 'Terms and Conditions',
      },
    },

    companyCreationDocs: {
      add: 'Ajouter les documents pour l’administration',
      review: 'Documents pour l’administration',
    },

    companyFinancialInfo: {
      add: 'Financial information',
      review: 'Financial information',
    },

    companyPapers: {
      add: 'Add proof of registration',
      hub: {
        label: {
          ei: {
            add: 'Avis Sirene',
            review: 'Avis Sirene',
          },
          nonEi: {
            add: 'Kbis document',
            review: 'Kbis document',
          },
        },
      },
      review: 'Proof of registration',
    },

    complianceAndPersonalAddress: {
      add: 'Complete your personal information',
      review: 'Your information',
    },

    draftStatutes: {
      add: 'Add the company’s draft statutes',
      review: 'Company’s draft statutes',
    },

    id: {
      home: {
        label: {
          add: 'Add proof of identity (ID card, passport, residence permit)',
          review: 'Proof of identity',
        },
      },
      hub: {
        description: {
          add: 'Identity card, passeport or residency card',
          review: 'Document sent for verification',
        },
        label: {
          add: 'Proof of identity',
          review: 'Proof of identity',
        },
      },
    },

    mandate: {
      add: 'Add mandate',
      review: 'Mandate',
    },

    pricingPlan: {
      description: {
        review: 'Shine {plan}',
      },
      label: {
        add: 'Your offer',
        review: 'Your offer',
      },
    },

    proofOfAddress: {
      add: 'Add proof of address',
      review: 'Proof of address',
    },

    proofOfFunds: {
      add: 'Add proof of funds',
      review: 'Proof of funds',
    },

    qes: {
      home: {
        label: {
          add: 'Electronically sign your identity',
          review: 'Electronically sign your identity',
        },
      },
      hub: {
        description: {
          add: 'Missing electronic signature',
          review: 'Missing electronic signature',
        },
      },
    },

    registerBeneficiaries: {
      description: {
        review: 'Beneficial owners declared',
      },
      label: {
        add: 'Beneficial owners',
        review: 'Beneficial owners',
      },
    },

    shineStart: {
      add: 'My Micro-Entreprise',
      review: 'My Micro-Entreprise',
    },

    statutes: {
      add: 'Add the company’s statutes',
      hub: {
        label: {
          add: 'Company statutes',
          review: 'Company statutes',
        },
      },
      review: 'Company’s statutes',
    },
  },

  fr: {
    agreement: {
      description: {
        review: 'CGU acceptées et signées',
      },
      label: {
        add: 'Conditions Générales d’Utilisation',
        review: 'Conditions Générales d’Utilisation',
      },
    },
    companyCreationDocs: {
      add: 'Ajouter les documents pour l’administration',
      review: 'Documents pour l’administration',
    },

    companyFinancialInfo: {
      add: 'Informations financières',
      review: 'Informations financières',
    },

    companyPapers: {
      add: 'Ajouter une preuve d’immatriculation',
      hub: {
        label: {
          ei: {
            add: 'Avis Sirene',
            review: 'Avis Sirene',
          },
          nonEi: {
            add: 'Document Kbis',
            review: 'Document Kbis',
          },
        },
      },
      review: 'Preuve d’immatriculation',
    },

    complianceAndPersonalAddress: {
      add: 'Compléter vos informations personnelles',
      review: 'Vos informations',
    },

    draftStatutes: {
      add: 'Ajouter le projet de statuts de l’entreprise',
      review: 'Projet de statuts de l’entreprise',
    },

    id: {
      home: {
        label: {
          add: 'Ajouter un justificatif d’identité (CNI, passeport, titre de séjour)',
          review: 'Preuve d’identité',
        },
      },
      hub: {
        description: {
          add: 'Carte d’identité, passeport ou titre de séjour',
          review: 'Document envoyé pour vérification',
        },
        label: {
          add: 'Justificatif d’identité',
          review: 'Justificatif d’identité',
        },
      },
    },

    mandate: {
      add: 'Ajouter votre mandat',
      review: 'Votre mandat',
    },

    pricingPlan: {
      description: {
        review: 'Shine {plan}',
      },
      label: {
        add: 'Votre offre',
        review: 'Votre offre',
      },
    },

    proofOfAddress: {
      add: 'Ajouter un justificatif de domicile',
      review: 'Justificatif de domicile',
    },

    proofOfFunds: {
      add: 'Ajouter une preuve de fonds',
      review: 'Preuve de fonds',
    },

    qes: {
      home: {
        label: {
          add: 'Signer électroniquement votre identité',
          review: 'Signer électroniquement votre identité',
        },
      },
      hub: {
        description: {
          add: 'Signature électronique manquante',
          review: 'Signature électronique manquante',
        },
      },
    },

    registerBeneficiaries: {
      description: {
        review: 'Bénéficiaires effectifs déclarés',
      },
      label: {
        add: 'Liste des bénéficiaires effectifs',
        review: 'Liste des bénéficiaires effectifs',
      },
    },

    shineStart: {
      add: 'Ma micro-entreprise',
      review: 'Ma micro-entreprise',
    },

    statutes: {
      add: 'Ajouter les statuts de l’entreprise',
      hub: {
        label: {
          add: 'Statuts de l’entreprise',
          review: 'Statuts de l’entreprise',
        },
      },
      review: 'Statuts de l’entreprise',
    },
  },
} as const);

export default locales;
